export const actFormTypeIds = {
    undefined: 0,
    act: 1,
    direction: 2
}